import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import { Link, useParams } from "react-router-dom";
import LayoutOne from "../layouts/LayoutOne";
import SectionHeroBanner from "../components/Common/SectionHeroBanner";
import MainTitle from "../components/Common/MainTitle";
import { BLOG_POSTS, NEWS_POSTS } from "../data/mediaContent";

const MediaListPage = () => {
  const { type } = useParams();
  const isBlog = type === "blog";
  const posts = isBlog ? BLOG_POSTS : NEWS_POSTS;
  const label = isBlog ? "Blog" : "News";

  return (
    <Fragment>
      <MetaTags>
        <title>{`${label} | South Asia Consultancy`}</title>
        <meta
          name="description"
          content={`${label} updates from South Asia Consultancy on oil and gas technology, manpower, and operations.`}
        />
      </MetaTags>
      <LayoutOne>
        <SectionHeroBanner title={`${label} Articles`} className="sectionAboutBg" />
        <div className="container py-5 sac-page-shell">
          <MainTitle text={`${label} Library`} className="text-center" position="center" width="180px" />
          <p className="sac-intro text-center">Showing {posts.length} SEO-ready {label.toLowerCase()} pages.</p>
          <div className="row mt-4">
            {posts.map((post) => (
              <article key={post.slug} className="col-md-6 mb-4">
                <div className="sac-content-card h-100">
                  <p className="sac-badge mb-2">{post.category}</p>
                  <h2 className="MainTitle" style={{ fontSize: "22px" }}>
                    {post.title}
                  </h2>
                  <p className="text-muted mb-2" style={{ fontSize: "12px", letterSpacing: "0.3px", textTransform: "uppercase" }}>
                    {post.date}
                  </p>
                  <p className="fs16px lnh-30">{post.excerpt}</p>
                  <Link to={`/media/${type}/${post.slug}`} className="color-primary fw600">
                    Read full article
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

export default MediaListPage;
